import { Component, OnInit } from "@angular/core";
import { LoaderStageInterface } from "./loader-stage.interface";
import { ObservablesService } from "../../../../Services/observables/observables";
import { ActionApiService } from "../../../../Services/action-api/action-api.service";
import {OnDestroy} from '@angular/core'
@Component({
  selector: "app-mpq3-dr-preloader",
  templateUrl: "./mpq3-dr-preloader.component.html",
  styleUrls: ["./mpq3-dr-preloader.component.scss"]
})
export class Mpq3DrPreloaderComponent implements OnInit,OnDestroy  {

  stages: LoaderStageInterface[];
  stageCounter = 0;
  secondCounter = 0;
  loaderInterval;
  shouldShowFirstTransition: boolean = false;
  shouldShowSecondTransition: boolean = false;

  constructor(
    private actionApiService: ActionApiService,
    private observablesService: ObservablesService,
  ) {
    this.stages = [
      {
        title: "Year built",
        isFirstStep: false,
        isSecondStep: false
      },
      {
        title: "Square footage",
        isFirstStep: false,
        isSecondStep: false
      },
      {
        title: "Additional details",
        isFirstStep: false,
        isSecondStep: false
      },
      {
        title: "Ok, we're all set",
        isFirstStep: false,
        isSecondStep: false
      }
    ];
  }

  ngOnInit() {
    this.loaderInterval = setInterval(async () => {
      if (
        this.stages[this.stageCounter] &&
        this.stages[this.stageCounter].isFirstStep
      ) {
        this.stages[this.stageCounter].isSecondStep = true;
        this.stageCounter++;
      } else if (this.stages[this.stageCounter]) {
        this.stages[this.stageCounter].isFirstStep = true;
      }
      this.secondCounter++;
      if (this.secondCounter !== 0 && this.secondCounter % 3 === 0) {
        this.getSubmissionStatusFromServer();
      }
    }, 1000);
    this.iniSubscriptionForSubmissionResult();
  }

  ngOnDestroy(): void {
    clearInterval(this.loaderInterval);
    window.location.reload();
  }

  async getSubmissionStatusFromServer(): Promise<void> {
    const ajaxtInfo = {
      action: "SubmissionLoaderCheckForResults",
      elementSrc: null,
      stage: "EditAddress",
      notRenderPage: true,
      conditions: ""
    };
    const requestBody = { data: {}, info: ajaxtInfo };
    // go to server only every 3 seconds //
    await this.actionApiService.invokeAction(
      requestBody,
      null,
      "SubmissionLoaderCheckForResults"
    );
  }

  iniSubscriptionForSubmissionResult(): void {
    this.observablesService.SubmissionLoaderCheckForResults.subscribe(res => {
       if (res && res.data.statusMpq3DrSubmission === "Success") {
        window.location.href = res.data.url;
        clearInterval(this.loaderInterval);
      }
       if (res && res.data.statusMpq3DrSubmission === "Failure") {
        clearInterval(this.loaderInterval);
        this.shouldShowFirstTransition = true;
        setTimeout(() => {
          this.shouldShowSecondTransition = true;
        }, 3000);
        setTimeout(() => {
          window.location.assign(res.data.stage);
          // this.router.navigate([res.data.stage]);
          // window.location.reload();
        }, 6000);
      }
    });
  }
}
